export default {
	inserted: function (el, binding, vnode) {
		let operateData = binding.value,
			leftEl = operateData.left,
			rightEl = operateData.right,
			leftMaxWidth = operateData.max,
			leftMinWidth = operateData.min,
			localName = leftEl;

		let left = document.getElementById(leftEl)
		let right = document.getElementById(rightEl)
		//判断是否存在dragEl
		let dragId = "dragEl" + leftEl,
			dragEl = document.getElementById(dragId)
		if (!dragEl) {
			dragEl = document.createElement('div');
			dragEl.className = "drag-btn"
			//dragEl.style.height = left.offsetHeight+"px";
			dragEl.id = dragId
			left.after(dragEl);
		}
		let box = operateData.parent || left.parentElement;
		let leftElWidth = left.offsetWidth
		let leftWidth = localStorage.getItem(localName) || leftElWidth || 200
		reloadEvent(leftWidth)
		function reloadEvent(moveLen) {
			dragEl.style.left = moveLen
			left.style.width = moveLen + 'px'
			right.style.width = (box.clientWidth - moveLen - 10) + 'px'
		}
		dragEl.onmousedown = function (e) {
			let startX = e.clientX
			dragEl.left = dragEl.offsetLeft
			document.onmousemove = function (e) {
				let endX = e.clientX
				let moveLen = dragEl.left + (endX - startX)
				let maxT = box.clientWidth - dragEl.offsetWidth
				if (moveLen < leftMinWidth) {
					moveLen = leftMinWidth
				}
				if (moveLen > leftMaxWidth) {
					moveLen = leftMaxWidth
				}
				reloadEvent(moveLen);
				var myEvent = new Event('resize');
				window.dispatchEvent(myEvent);//触发resize事件
				localStorage.setItem(localName, moveLen)
			}
			document.onmouseup = function () {
				document.onmousemove = null
				document.onmouseup = null
				dragEl.releaseCapture && dragEl.releaseCapture()
			}
			dragEl.setCapture && dragEl.setCapture()
			return false
		}
	}
}
